import { useState, useEffect } from 'react';

import { breakpoints } from '../ui/variables';
import { useWindowSize } from './useWindowSize';

export const useBreakpoint = () => {
  const windowSize = useWindowSize();

  const [breakpoint, setBreakpoint] = useState({
    name: 'all',
    width: 0,
  });

  useEffect(() => {
    if (
      windowSize.width < breakpoints.iphone8.width &&
      breakpoint.name !== 'iphone'
    ) {
      setBreakpoint({
        name: 'iphone',
        width: breakpoints.iphone.width,
      });
    } else if (
      windowSize.width >= breakpoints.iphone8.width &&
      windowSize.width < breakpoints.iphonePlus.width &&
      breakpoint.name !== 'iphone8'
    ) {
      setBreakpoint({
        name: 'iphone8',
        width: breakpoints.iphone8.width,
      });
    } else if (
      windowSize.width >= breakpoints.iphonePlus.width &&
      windowSize.width < breakpoints.ipad.width &&
      breakpoint.name !== 'iphone-plus'
    ) {
      setBreakpoint({
        name: 'iphone-plus',
        width: breakpoints.iphonePlus.width,
      });
    } else if (
      windowSize.width >= breakpoints.ipad.width &&
      windowSize.width < breakpoints.ipadLandscape.width &&
      breakpoint.name !== 'ipad'
    ) {
      setBreakpoint({
        name: 'ipad',
        width: breakpoints.ipad.width,
      });
    } else if (
      windowSize.width >= breakpoints.ipadLandscape.width &&
      windowSize.width < breakpoints.hd.width &&
      breakpoint.name !== 'ipad-landscape'
    ) {
      setBreakpoint({
        name: 'ipad-landscape',
        width: breakpoints.ipadLandscape.width,
      });
    } else if (
      windowSize.width >= breakpoints.hd.width &&
      windowSize.width < breakpoints.wxgaPlus.width &&
      breakpoint.name !== 'hd'
    ) {
      setBreakpoint({
        name: 'hd',
        width: breakpoints.hd.width,
      });
    } else if (
      windowSize.width >= breakpoints.wxgaPlus.width &&
      windowSize.width < breakpoints.uxga.width &&
      breakpoint.name !== 'wxga-plus'
    ) {
      setBreakpoint({
        name: 'wxga-plus',
        width: breakpoints.wxgaPlus.width,
      });
    } else if (
      windowSize.width >= breakpoints.uxga.width &&
      windowSize.width < breakpoints.fullHd.width &&
      breakpoint.name !== 'uxga'
    ) {
      setBreakpoint({
        name: 'uxga',
        width: breakpoints.uxga.width,
      });
    } else if (
      windowSize.width >= breakpoints.fullHd.width &&
      breakpoint.name !== 'full-hd'
    ) {
      setBreakpoint({
        name: 'full-hd',
        width: breakpoints.fullHd.width,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowSize.width]);

  return breakpoint;
};
